import { EmployeeLeaveBalance } from '../types';

export function leaveBalanceUnit(balance: EmployeeLeaveBalance): 'hours' | 'days' {
  return balance.displayUnit ?? (balance.accrualsBasedOnHours ? 'hours' : 'days');
}

export function formatLeaveBalanceAmount(value: number | undefined, unit: 'hours' | 'days'): string {
  const n = value ?? 0;
  const label = unit === 'hours' ? (n === 1 ? 'hour' : 'hours') : n === 1 ? 'day' : 'days';
  return `${n} ${label}`;
}

export function shouldShowEntitlement(balance: EmployeeLeaveBalance): boolean {
  if (balance.showEntitlement === false) return false;
  if (balance.showEntitlement === true) return true;
  return (balance.displayEntitled ?? balance.entitledDays ?? 0) > 0;
}

export function getDisplayAccrued(balance: EmployeeLeaveBalance): number {
  return balance.displayAccrued ?? (leaveBalanceUnit(balance) === 'hours' ? balance.accruedHours ?? 0 : balance.accruedDays);
}

export function getDisplayEntitled(balance: EmployeeLeaveBalance): number | null {
  if (!shouldShowEntitlement(balance)) return null;
  return balance.displayEntitled ?? (leaveBalanceUnit(balance) === 'hours' ? balance.entitledHours ?? 0 : balance.entitledDays);
}

export function getDisplayTaken(balance: EmployeeLeaveBalance): number {
  return balance.displayTaken ?? (leaveBalanceUnit(balance) === 'hours' ? balance.takenHours ?? 0 : balance.takenDays);
}

export function getDisplayPending(balance: EmployeeLeaveBalance): number {
  return balance.displayPending ?? (leaveBalanceUnit(balance) === 'hours' ? balance.pendingHours ?? 0 : balance.pendingDays);
}

export function getDisplayRemaining(balance: EmployeeLeaveBalance): number {
  return balance.displayRemaining ?? (leaveBalanceUnit(balance) === 'hours' ? balance.remainingHours ?? 0 : balance.remainingDays);
}

export function getDisplayCarriedForward(balance: EmployeeLeaveBalance): number {
  return balance.displayCarriedForward ?? (leaveBalanceUnit(balance) === 'hours' ? balance.carriedForwardHours ?? 0 : balance.carriedForwardDays);
}

export function getRemainingLabel(unit: 'hours' | 'days'): string {
  return unit === 'hours' ? 'hours remaining' : 'days remaining';
}
